import { STUDENT_APP_ORIGIN } from "src/shared/constants/constants";

/** Route path for the standalone DMV permit-test auto-booking page. */
export const PERMIT_TEST_BOOKING_PATH = "/permit-test";

/**
 * Fully-qualified URL for the auto-booking page — safe to text/email directly
 * to a student (e.g. a "time to book your permit test" nudge). Mirrors
 * `CLP_SCHEDULE_URL` in the compliance feature.
 */
export const PERMIT_TEST_BOOKING_URL = `${STUDENT_APP_ORIGIN}${PERMIT_TEST_BOOKING_PATH}`;

/**
 * Carries a reschedule reason from the Practice Hub into the booking page, so
 * the milestone history records WHY the exam moved even though the date itself
 * now comes from the DMV reservation rather than from the student.
 */
export const RESCHEDULE_REASON_PARAM = "reason";

/**
 * Standalone page showing the student's booked DMV permit-test appointment:
 * date, office, confirmation number, check-in barcode, and the DMV's
 * reschedule link. Safe to text/email to a student who needs to reschedule.
 */
export const DMV_APPOINTMENT_PATH = "/dmv-appointment";

export const DMV_APPOINTMENT_URL = `${STUDENT_APP_ORIGIN}${DMV_APPOINTMENT_PATH}`;
